import '.a{display:flex;}.ssr-plugin'
import '.g{justify-content:center;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.bn{background-color:var(--shades-blue-50);}.ssr-plugin'
import '.i{color:var(--shades-blue-300);}.ssr-plugin'
import '.d1{border-radius:0.5rem;}.ssr-plugin'
import '.gq{width:2rem;}.ssr-plugin'
import '.gl{height:2rem;}.ssr-plugin'
import '.dx{aspect-ratio:1/1;}.ssr-plugin'
import { Text } from '../typography/Text'
import { IconButton } from '../button/IconButton'
import {
  faXmark,
  faFile,
  faImage,
  faCircleNotch,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Image } from '../image/Image'

export type FileDisplayProps = {
  type: 'document' | 'image'
  name: string
  src?: string
  onRemove?: VoidFunction
  isLoading?: boolean
}

const iconVariant: Record<FileDisplayProps['type'], IconDefinition> = {
  image: faImage,
  document: faFile,
}

const fileDisplayStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  padding: '0.5rem',
  border: 'var(--blue-border)',
  backgroundColor: 'var(--shades-white)',
  boxShadow: '0 3px 10px 0 rgba(0, 0, 0, 0.05)',
  borderRadius: '0.625rem',
  textDecoration: 'none',
  color: 'inherit',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: 'var(--gray-100)',
  },
}

export const FileDisplay = ({
  type,
  name,
  src,
  onRemove,
  isLoading = false,
}: FileDisplayProps) => {
  const content = (
    <>
      {type === 'image' && src && !isLoading ? (
        <Image
          src={src}
          alt={name}
          resizeWidth={32}
          style={{
            width: '2rem',
            height: '2rem',
            objectFit: 'cover',
            borderRadius: '0.5rem',
          }}
        />
      ) : (
        <div className="a g c bn i d1 gq gl dx"
        >
          {isLoading ? (
            <FontAwesomeIcon
              icon={faCircleNotch}
              spin
              style={{ fontSize: '1rem' }}
            />
          ) : (
            <FontAwesomeIcon icon={iconVariant[type]} />
          )}
        </div>
      )}
      <Text.Small
        isBold
        style={{
          textWrap: 'nowrap',
          overflow: 'hidden',
          maxWidth: '7rem',
          textOverflow: 'ellipsis',
        }}
      >
        {name}
      </Text.Small>
    </>
  )

  if (src) {
    return (
      <styled.a
        href={src}
        download={name}
        style={fileDisplayStyle}
        onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
          if (onRemove) {
            e.stopPropagation()
          }
        }}
      >
        {content}
        {onRemove && !isLoading && (
          <div className="a c"
            onClick={(e: React.MouseEvent) => {
              e.preventDefault()
              e.stopPropagation()
              onRemove()
            }}
          >
            <IconButton
              size="small"
              variant="transparent"
              icon={faXmark}
              onClick={() => {}}
              style={{
                border: 0,
                width: '1rem',
                height: '1rem',
              }}
            />
          </div>
        )}
      </styled.a>
    )
  }

  return (
    <styled.div style={fileDisplayStyle}>
      {content}
      {onRemove && !isLoading && (
        <IconButton
          size="small"
          variant="transparent"
          icon={faXmark}
          onClick={onRemove}
          style={{
            border: 0,
            width: '1rem',
            height: '1rem',
          }}
        />
      )}
    </styled.div>
  )
}
